// extracted by mini-css-extract-plugin
module.exports = {"filterTitle":"Filter_filterTitle__1ijXv"};